module.exports = __webpack_public_path__ + "img/green_circle.4f08ba5f.svg";